import {Routes} from '@angular/router';
import {InitComponent} from './features/init/init.component';
import {LandingComponent} from './features/landing/landing.component';
import {ThankYouComponent} from './features/thank-you/thank-you.component';
import {AdmissionComponent} from "./features/admission/admission.component";
import {NotFoundComponent} from "./features/not-found/not-found.component";

export const routes: Routes = [
    {
        path: '',
        component: InitComponent
    },
    {
        path: 'landing',
        component: LandingComponent
    },
    {
        path: 'not-found',
        component: NotFoundComponent
    },
    {
        path: 'admission',
        component: AdmissionComponent
    },
    {
        path: 'thank-you',
        component: ThankYouComponent
    }
];
